$(() => {
  $.validator.setDefaults({
    highlight(element) {
      const $fg = $(element).closest('.form-group, .form_group_xs');
      $fg.removeClass('has-success').addClass('has-error');
    },
    unhighlight(element) {
      const $fg = $(element).closest('.js-error-placement');
      $fg.removeClass('has-error').addClass('has-success');
    },
    errorClass: 'help-block',
  });
});
